// 貸主、所有者、管理会社
const Ea = {
  namespaced: true,

  state: {
    // 貸主、所有者、管理会社一覧/編集モーダル
    modal: false,
    modalType: null,
    // 貸主、所有者、管理会社 プルダウンリスト
    listKashi: [],
    listShoyu: [],
    listKanri: [],
    // 貸主、所有者、管理会社 検索項目
    search: {
      name: '',
      tel: '',
      page: 1,
      perPage: 20,
    },
    // 登録/更新情報
    formItem: {
      f_type_ksk: null,
      company_private_ksk: null, // 区分
      name_ksk: '',
      kana_ksk: '',
      birth_year_ksk: null,
      birth_month_ksk: null,
      birth_day_ksk: null,
      zip1_ksk: null,
      zip2_ksk: null,
      pref_ksk: null,
      shiku_ksk: null,
      choson_ksk: null,
      aza_ksk: null,
      address_else_ksk: '',
      tel_ksk: '',
      mobile_number_ksk: '',
      fax_ksk: '',
      last_tell_time1_ksk: '',
      last_tell_time2_ksk: '',
      last_tell_time3_ksk: '',
      last_tell_time4_ksk: '',
      last_tell_time5_ksk: '',
      bank_name_ksk: '',
      bank_shop_ksk: '',
      bank_type_ksk: null,
      bank_no_ksk: '',
      bank_nominee_ksk: '',
      charge_person1_name_ksk: '',
      charge_person1_tel_ksk: '',
      charge_person1_mail_ksk: '',
      charge_person2_name_ksk: '',
      charge_person2_tel_ksk: '',
      charge_person2_mail_ksk: '',
      charge_person3_name_ksk: '',
      charge_person3_tel_ksk: '',
      charge_person3_mail_ksk: '',
      charge_person4_name_ksk: '',
      charge_person4_tel_ksk: '',
      charge_person4_mail_ksk: '',
      charge_person5_name_ksk: '',
      charge_person5_tel_ksk: '',
      charge_person5_mail_ksk: '',
      note_ksk: '',
      different_zip1_ksk: null,
      different_zip2_ksk: null,
      different_pref_ksk: null,
      different_shiku_ksk: null,
      different_choson_ksk: null,
      different_aza_ksk: null,
      different_address_else_ksk: '',
      different_addressee_ksk: '',
      f_target_flag_ksk: null,
      target_tel1_ksk: '',
      target_tel2_ksk: '',
      target_fax_ksk: '',
      target_mobile_number_ksk: '',
      target_mail_ksk: '',
      target_company_address_ksk: '',
      target_company_tel_ksk: '',
      target_work_description_ksk: '',
      target_comment_ksk: '',
    },
    // 登録/更新時に必要なパーツ
    formParts: {
      prefList: [],
      shikuList: [],
      chosonList: [],
      azaList: [],
      differentPrefList: [],
      differentShikuList: [],
      differentChosonList: [],
      differentAzaList: [],
    },
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getModalType: state => {
      return state.modalType
    },
    getListKashi: state => {
      return state.listKashi
    },
    getListShoyu: state => {
      return state.listShoyu
    },
    getListKanri: state => {
      return state.listKanri
    },
    getSearch: state => {
      return state.search
    },
    getChargePersonList: state => {
      return state.chargePersonList
    },
    getFormItem: state => {
      return state.formItem
    },
    getFormParts: state => {
      return state.formParts
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setModalType(state, type) {
      state.modalType = type
    },
    setListKashi(state, list) {
      state.listKashi = list
    },
    setListShoyu(state, list) {
      state.listShoyu = list
    },
    setListKanri(state, list) {
      state.listKanri = list
    },
    setSearch(state, search) {
      state.search = search
    },
    setChargePersonList(state, chargePersonList) {
      state.chargePersonList = chargePersonList
    },
    setFormItem(state, formItem) {
      state.formItem = formItem
    },
    setFormParts(state, formParts) {
      state.formParts = formParts
    },
  },
  actions: {
    setModal({ commit }, item) {
      commit('setModalType', item.type)
      commit('setModal', true)
    },
    resetSearch({ commit }) {
      const search = {
        name: '',
        tel: '',
        page: 1,
        perPage: 20,
      }
      commit('setSearch', search)
    },
    resetFormItem({ commit }) {
      const formItem = {
        f_type_ksk: null,
        company_private_ksk: null, // 区分
        name_ksk: '',
        kana_ksk: '',
        birth_year_ksk: null,
        birth_month_ksk: null,
        birth_day_ksk: null,
        zip1_ksk: null,
        zip2_ksk: null,
        pref_ksk: null,
        shiku_ksk: null,
        choson_ksk: null,
        aza_ksk: null,
        address_else_ksk: '',
        tel_ksk: '',
        mobile_number_ksk: '',
        fax_ksk: '',
        last_tell_time1_ksk: '',
        last_tell_time2_ksk: '',
        last_tell_time3_ksk: '',
        last_tell_time4_ksk: '',
        last_tell_time5_ksk: '',
        bank_name_ksk: '',
        bank_shop_ksk: '',
        bank_type_ksk: null,
        bank_no_ksk: '',
        bank_nominee_ksk: '',
        charge_person1_name_ksk: '',
        charge_person1_tel_ksk: '',
        charge_person1_mail_ksk: '',
        charge_person2_name_ksk: '',
        charge_person2_tel_ksk: '',
        charge_person2_mail_ksk: '',
        charge_person3_name_ksk: '',
        charge_person3_tel_ksk: '',
        charge_person3_mail_ksk: '',
        charge_person4_name_ksk: '',
        charge_person4_tel_ksk: '',
        charge_person4_mail_ksk: '',
        charge_person5_name_ksk: '',
        charge_person5_tel_ksk: '',
        charge_person5_mail_ksk: '',
        note_ksk: '',
        different_zip1_ksk: null,
        different_zip2_ksk: null,
        different_pref_ksk: null,
        different_shiku_ksk: null,
        different_choson_ksk: null,
        different_aza_ksk: null,
        different_address_else_ksk: '',
        different_addressee_ksk: '',
        f_target_flag_ksk: null,
        target_tel1_ksk: '',
        target_tel2_ksk: '',
        target_fax_ksk: '',
        target_mobile_number_ksk: '',
        target_mail_ksk: '',
        target_company_address_ksk: '',
        target_company_tel_ksk: '',
        target_work_description_ksk: '',
        target_comment_ksk: '',
      }
      commit('setFormItem', formItem)
    },
    resetFormParts({ commit }) {
      const formParts = {
        prefList: [],
        shikuList: [],
        chosonList: [],
        azaList: [],
      }
      commit('setFormParts', formParts)
    },
  },
}

export default Ea
